import { Typography } from "antd";
import { Colors } from "../../config";

export default function ErrorMessage({ children }) {
    return <Typography.Text className="text-xs pl-2 font-medium" type="danger">{children}</Typography.Text>
}